import React, { useEffect } from 'react';
import { HeaderPortal } from '../header/HeaderPortal';
import { FooterPortal } from '../footer/FooterPortal';
import { ProductCompareBar } from '@jbhi-fi/components/src/ProductCompare';
import { createRoot } from 'react-dom/client';
import { BaseContentProvider } from '../stack/components/BaseContentProvider/BaseContentProvider';
import { sassOptOut } from '../../../utils/sassOptOut';
import { TooltipPortal } from '../header/TooltipPortal';
import { CouponsModalWrapper } from '../cart/couponsModalWrapper';
import { PerksInfoPortal } from '../perksInfo/PerksInfoPortal';
import { initialiseInsights } from '../../../utils/algolia/search-insights';
import { useLocalisationContext } from '../localisation/context/LocalisationContext';
import { LOCATION_PERMISSION_COOKIE } from '../../../utils/location/locationHelper';
import Cookies from 'js-cookie';
import { useLocationSearch } from '../location-search/useLocationSearch';

export type LayoutProps = {
  shouldHideCompareBar?: boolean;
  children?: React.ReactNode;
};

export const DefaultLayout = ({ shouldHideCompareBar, children }: LayoutProps) => {
  initialiseInsights();
  const { selectedStore, updateSelectedStoreAndDeliveryLocation, deliveryLocation } = useLocalisationContext();
  const shouldRequestLocation = (!selectedStore || !deliveryLocation) && !Cookies.get(LOCATION_PERMISSION_COOKIE);
  const { fetchAndSelectUserLocation } = useLocationSearch(updateSelectedStoreAndDeliveryLocation);

  useEffect(() => {
    if (shouldRequestLocation) {
      fetchAndSelectUserLocation();
    }
  }, [shouldRequestLocation]);

  return (
    <>
      <HeaderPortal />
      <TooltipPortal />
      <PerksInfoPortal />
      {!shouldHideCompareBar ? <ProductCompareBar /> : null}
      <CouponsModalWrapper />

      {children}
      <FooterPortal />
    </>
  );
};

/* Used to draw the layout on pages that don't have a template file with a main react root.  E.G the 404 page.*/
export const drawDefaultLayout = ({
  shouldHideCompareBar,
  containerId,
}: { shouldHideCompareBar?: boolean; containerId?: string } = {}) => {
  const container = containerId ? document.getElementById(containerId) : window.document.createElement('div');
  sassOptOut('forms');
  initialiseInsights();

  if (container) {
    const root = createRoot(container);
    root.render(
      <BaseContentProvider>
        <DefaultLayout shouldHideCompareBar={shouldHideCompareBar} />
      </BaseContentProvider>
    );
  }
};
